var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCalendar = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03716 13.069H4.02123V10.0531H7.03716V13.069Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03716 20.1062H4.02123V17.0902H7.03716V20.1062Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5557 13.069H13.5717V10.0531H10.5557V13.069Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5717 20.1062H10.5557V17.0902H13.5717V20.1062Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0902 13.069H20.1062V10.0531H17.0902V13.069Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1062 20.1062H17.0902V17.0902H20.1062V20.1062Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20.1062C0 22.327 1.80037 24.1274 4.02123 24.1274H20.1062C22.327 24.1274 24.1274 22.327 24.1274 20.1062V4.02123C24.1274 1.80037 22.327 0 20.1062 0H4.02123C1.80037 0 0 1.80037 0 4.02123V20.1062ZM20.1062 2.01062H4.02123C2.9108 2.01062 2.01062 2.9108 2.01062 4.02123V6.03185L22.1168 6.03185V4.02123C22.1168 2.9108 21.2166 2.01062 20.1062 2.01062ZM22.1168 20.1062V8.04247L2.01062 8.04247V20.1062C2.01062 21.2166 2.9108 22.1168 4.02123 22.1168H20.1062C21.2166 22.1168 22.1168 21.2166 22.1168 20.1062Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCalendar);
export default ForwardRef;